import * as React from 'react';
import * as classnames from 'classnames';
import { Box } from './Responsive';
import styled, { ThemeProvider } from 'styled-components';
import { breakpoint, Breakpoints, ContentSpacing } from '@estee/elc-base-theme';
import { GRID_SIZE } from '../constants';

export interface IBoxProps {
    className?: string;
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    children?: React.ReactNode;
}

const mapBreakpointsToArray = (
    xs: number = 12,
    sm?: number,
    md?: number,
    lg?: number
): number[] => {
    const _xs = xs / GRID_SIZE;
    const _sm = sm ? sm / GRID_SIZE : _xs;
    const _md = md ? md / GRID_SIZE : _sm;
    const _lg = lg ? lg / GRID_SIZE : _md;

    return [_xs, _sm, _md, _lg];
};

const StyledBox = styled(Box)`
    padding: 0 ${ContentSpacing.space6};
    ${breakpoint('desktop')`
        padding: 0 ${ContentSpacing.space8};
    `};
`;

const theme = {
    breakpoints: Object.keys(Breakpoints)
        .sort((a: string, b: string) => Breakpoints[a] - Breakpoints[b])
        .map((key: string) => `${Breakpoints[key]}px`)
};

export class Column extends React.Component<IBoxProps> {
    public render() {
        const { className, xs, sm, md, lg, children } = this.props;

        const width = mapBreakpointsToArray(xs, sm, md, lg);
        const classNames = classnames('js-grid-column', 'elc-grid-column', className);

        return (
            <ThemeProvider theme={theme}>
                <StyledBox className={classNames} width={width}>
                    {children}
                </StyledBox>
            </ThemeProvider>
        );
    }
}
